import { MenuCategory } from "@/types/common";
import { buildGenderMegaMenuColumns } from "./mega-menu-columns";

/** Prime banner — cột NEW & TRENDING (adidas.com/us WOMEN, World Cup season) */
export const womenMegaMenuBanner = {
  href: "/women-prime_delivery",
  src: "https://brand.assets.adidas.com/image/upload/f_auto,q_auto,fl_lossy/bwp_adidas_content_slot_navigation_d_dfbf3d31ce.png",
  alt: "Fast, free delivery with Prime",
};

export const womenMenuData: MenuCategory[] = [
  {
    title: "NEW & TRENDING",
    titleHref: "/women-new_trending",
    items: [
      { name: "New Arrivals", href: "/women-new_arrivals", translationKey: "newArrivals" },
      { name: "Best Sellers", href: "/women-best_sellers", translationKey: "bestSellers" },
      { name: "Trending Now", href: "/women-trending", translationKey: "trendingNow" },
      { name: "Shop FIFA World Cup™", href: "/women-fifa_world_cup", translationKey: "shopFifaWorldCup" },
      { name: "Summer Shop ☀️", href: "/women-summer", translationKey: "summerShop" },
      { name: "Pet Collection 🐈", href: "/pet", translationKey: "petCollectionWomen" },
      { name: "Balletcore 🩰", href: "/women-ballerina", translationKey: "balletcore" },
      { name: "Pride: Love Unites 🏳️‍🌈", href: "/women-pride", translationKey: "prideLoveUnites" },
      { name: "Spend $100 Save $30", href: "/women-shop", translationKey: "spend100Save30" },
    ],
  },
  {
    title: "SHOES",
    titleHref: "/women-shoes",
    items: [
      { name: "Running", href: "/women-running-shoes", translationKey: "running" },
      { name: "Soccer", href: "/women-soccer-shoes", translationKey: "soccer" },
      { name: "Sneakers", href: "/women-athletic_sneakers", translationKey: "sneakers" },
      { name: "Mary Janes & Flats", href: "/women-flats", translationKey: "maryJanesFlats" },
      { name: "Golf", href: "/women-golf-shoes", translationKey: "golf" },
      { name: "Walking", href: "/women-walking-shoes", translationKey: "walking" },
      { name: "Slides & Sandals", href: "/women-slides", translationKey: "slidesSandals" },
      { name: "Platform Shoes", href: "/women-platform_shoes", translationKey: "platformShoes" },
      { name: "Low Profile", href: "/women-low_profile", translationKey: "lowProfile" },
      { name: "Workout & Gym", href: "/women-workout-shoes", translationKey: "workoutGym" },
      { name: "Basketball", href: "/women-basketball-shoes", translationKey: "basketball" },
      { name: "Shoes $90 & Under", href: "/women-under_90-shoes", translationKey: "shoesUnder90" },
    ],
  },
  {
    title: "CLOTHING",
    titleHref: "/women-clothing",
    items: [
      { name: "Pants", href: "/women-pants", translationKey: "pants" },
      { name: "Shirts & Tops", href: "/women-tops", translationKey: "shirtsAndTops" },
      { name: "Dresses & Skirts", href: "/women-dresses_skirts", translationKey: "dressesSkirts" },
      { name: "Tights & Leggings", href: "/women-tights_leggings", translationKey: "tightsLeggings" },
      { name: "Plus Size", href: "/women-plus_size", translationKey: "plusSize" },
      { name: "Tracksuits", href: "/women-tracksuits", translationKey: "tracksuits" },
      { name: "Graphic Tees", href: "/women-graphic_tees", translationKey: "graphicTees" },
      { name: "Jerseys", href: "/women-jerseys", translationKey: "jerseys" },
      { name: "Sports Bras", href: "/women-sports_bras", translationKey: "sportsBras" },
      { name: "Shorts", href: "/women-shorts", translationKey: "shorts" },
      { name: "Hoodies & Sweatshirts", href: "/women-hoodies_sweatshirts", translationKey: "hoodiesSweatshirts" },
      { name: "Jackets & Coats", href: "/women-jackets_coats", translationKey: "jacketsCoats" },
    ],
  },
  {
    title: "ACCESSORIES",
    titleHref: "/women-accessories",
    items: [
      { name: "Bags & Backpacks", href: "/women-bags_backpacks", translationKey: "bagsBackpacks" },
      { name: "Soccer Balls", href: "/women-soccer_balls", translationKey: "soccerBalls" },
      { name: "Hats & Beanies", href: "/women-hats_beanies", translationKey: "hatsAndBeanies" },
      { name: "Socks", href: "/women-socks", translationKey: "socks" },
      { name: "Water Bottles", href: "/women-water_bottles", translationKey: "waterBottles" },
      { name: "Sunglasses", href: "/women-sunglasses", translationKey: "sunglasses" },
    ],
  },
  {
    title: "SPORTS",
    titleHref: "/women-sports",
    items: [
      { name: "Basketball", href: "/women-basketball", translationKey: "basketball" },
      { name: "Cycling", href: "/women-cycling", translationKey: "cycling" },
      { name: "Golf", href: "/women-golf", translationKey: "golf" },
      { name: "Hiking", href: "/women-hiking", translationKey: "hiking" },
      { name: "Motorsport", href: "/women-motorsport", translationKey: "motorsport" },
      { name: "Outdoor", href: "/women-outdoor", translationKey: "outdoor" },
      { name: "Running", href: "/women-running", translationKey: "running" },
      { name: "Soccer", href: "/women-soccer", translationKey: "soccer" },
      { name: "Softball", href: "/women-softball", translationKey: "softball" },
      { name: "Swim", href: "/women-swim", translationKey: "swim" },
      { name: "Tennis", href: "/women-tennis", translationKey: "tennis" },
      { name: "Volleyball", href: "/women-volleyball", translationKey: "volleyball" },
      { name: "Workout & Gym", href: "/women-workout_gym", translationKey: "workoutGymSport" },
      { name: "Yoga", href: "/women-yoga", translationKey: "yoga" },
    ],
  },
  {
    title: "COLLECTIONS",
    titleHref: "/women-collections",
    items: [
      { name: "adicolor", href: "/women-adicolor", translationKey: "adicolor" },
      { name: "Campus", href: "/women-campus", translationKey: "campus" },
      { name: "Samba Jane", href: "/women-samba_jane", translationKey: "sambaJane" },
      { name: "Premium Collaborations", href: "/women-premium", translationKey: "premiumCollaborations" },
      { name: "adidas by Stella McCartney", href: "/women-stella_mccartney", translationKey: "adidasByStellaMccartney" },
      { name: "Gazelle", href: "/women-gazelle", translationKey: "gazelle" },
      { name: "Originals", href: "/women-originals", translationKey: "originals" },
      { name: "Samba", href: "/women-samba", translationKey: "samba" },
      { name: "Superstar", href: "/women-superstar", translationKey: "superstar" },
      { name: "Sportswear", href: "/women-sportswear", translationKey: "sportswear" },
      { name: "Firebird", href: "/women-firebird", translationKey: "firebird" },
      { name: "TERREX", href: "/women-terrex", translationKey: "terrex" },
      { name: "Y-3", href: "/women-y-3", translationKey: "y3" },
    ],
  },
];

export const womenMenuColumns = buildGenderMegaMenuColumns(womenMenuData, {
  shopByColorAfterHeading: "CLOTHING",
});
